// extracted by mini-css-extract-plugin
export default {"base":"CommentRemove_base__5wvPb"};